

module.exports = {
  "../assets/solution/banner.png": (function() { var id = 1056; return __webpack_require__.t(id, 1); })(),
  "../assets/solution/card_hardware.png": (function() { var id = 8145; return __webpack_require__.t(id, 1); })(),
  "../assets/solution/card_server.png": (function() { var id = 6036; return __webpack_require__.t(id, 1); })(),
  "../assets/solution/card_software.png": (function() { var id = 1922; return __webpack_require__.t(id, 1); })()
};
